import React, { useState, useEffect } from 'react'
import { string, node } from 'prop-types'
import { useFetch } from '../../utils/hooks'
import { APIENDPOINT, getCWPEnvironmentForURL } from '../../utils/common-utils'
import { buildNavItems } from './utils'

const largeSizeImage = window.AMPMSSITEPATH + 'images/shared/amp-site-logo-sm.png'
const smallSizeImage = window.AMPMSSITEPATH + 'images/shared/SOLID_WHITE_LOGO_SMALL.png'

/*
 * <HeaderPersonalized />
 * Renders the site header
 */

export const HeaderPersonalized = props => {
  const [contentIdentifier, setContentIdentifier] = useState(null)
  const [backgroundColor, setBackground] = useState(props)
  const [backgroundContrast, setbackgroundContrast] = useState(props)

  const env = getCWPEnvironmentForURL(window.location.href)

  const headerApiUrl =
    contentIdentifier && `${APIENDPOINT(env).base}halapi/documents/${contentIdentifier}`

  const { status, data, error } = useFetch(headerApiUrl)

  useEffect(() => {
    setContentIdentifier(props.contentIdentifier)
    props && props.backgroundColor
      ? setBackground(props.backgroundColor)
      : setBackground('u-bgColorBrand')
    props && props.backgroundContrast
      ? setbackgroundContrast(props.backgroundContrast)
      : setbackgroundContrast('Content--reversed')
  }, [props])

  const navItems = data.utilityNavigation
  const headerClasses = 'PageHeader amp-header ' + backgroundColor + ' ' + backgroundContrast

  const [popover, isPopoverVisible] = useState(false)

  let burgerMenuColor = 'u-bgColorWhite'
  let burgerTextMenuColor = 'u-bgColorWhite'
  if (backgroundColor === 'u-bgColorWhite') {
    burgerMenuColor = 'u-bgColorBrand'
    burgerTextMenuColor = 'u-textColorBrand'
  }

  const handleDialogOpen = classes => {
    if (!!classes.filter(item => item.includes('afig')).length) {
      const shareModalForm = document.querySelector('.afig-contact-form')
      return (shareModalForm.style.display = 'block')
    }
    return (shareModalForm.style.display = 'none')
  }

  return (
    <>
      <div className={headerClasses}>
        <div className='u-sizeConstrained'>
          <div className='u-flex u-flexRow u-flexJustifyBetween'>
            <button
              className='u-md-hidden u-lg-hidden amp-hamburger'
              onClick={() => isPopoverVisible(!popover)}>
              <div className='u-flex u-flexCol u-flexJustifyCenter u-flexAlignItemsCenter'>
                <div className='amp-hamburger-icon'>
                  <div aria-hidden='true' className={burgerTextMenuColor}>
                    <div
                      className={`amp-hamburger-icon-dash ${burgerMenuColor} u-marginTop4 u-marginBottom4`}>
                      &nbsp;
                    </div>
                    <div
                      className={`amp-hamburger-icon-dash ${burgerMenuColor} u-marginTop4 u-marginBottom4`}>
                      &nbsp;
                    </div>
                    <div
                      className={`amp-hamburger-icon-dash ${burgerMenuColor} u-marginTop4 u-marginBottom4`}>
                      &nbsp;
                    </div>
                  </div>
                  <span className='u-hiddenVisually'>Menu</span>
                </div>
                <div
                  className={`amp-hamburger-icon-label ${burgerTextMenuColor}" data-qa="HamburgerMenu`}>
                  Menu
                </div>
              </div>
            </button>
            <div className='u-flex u-sm-flexAlignSelfCenter amp-siteLogo'>
              <a
                href={
                  (data.desktopLogo && data.desktopLogo.url ? data.desktopLogo.url : '/') ||
                  (data.mobileLogo && data.mobileLogo.url ? data.mobileLogo.url : '/')
                }>
                <img
                  src={
                    data.desktopLogo && data.desktopLogo.image._meta.mirror.path
                      ? APIENDPOINT(env).baseGallery + data.desktopLogo.image._meta.mirror.path
                      : largeSizeImage
                  }
                  alt='Ameriprise Financial'
                  className='u-sm-hidden u-md-hidden'
                />
                <img
                  src={
                    data.mobileLogo && data.mobileLogo.image._meta.mirror.path
                      ? APIENDPOINT(env).baseGallery + data.mobileLogo.image._meta.mirror.path
                      : smallSizeImage
                  }
                  alt='Ameriprise Financial'
                  className='u-lg-hidden'
                />
              </a>
            </div>
            <div className='PageHeader-buttonWrap u-sm-hidden u-md-flexRow u-lg-flexRow u-sm-marginTop20'>
              {status === 'error' && <div>{error}</div>}
              {status === 'fetching' && <div className='loading'></div>}
              {status === 'fetched' && buildNavItems(navItems, handleDialogOpen)}
            </div>
          </div>
        </div>
      </div>
      {popover && (
        <div className='amp-nav u-borderVert u-borderColorNeutral u-borderTop0'>
          <div className='u-sizeConstrained amp-nav-inner u-flex Popover amp-nav-level-one is-visible'>
            <nav className='u-flex u-flexAlignItemsStretch amp-nav-level-one'>
              {status === 'error' && <div>{error}</div>}
              {status === 'fetching' && <div className='loading'></div>}
              {status === 'fetched' && (
                <>
                  <ul
                    className='List List--selectable amp-mainNav u-flexJustifyStart u-borderBottom0'
                    aria-label='menu'
                    data-qa='MainNavLevelOne'>
                    {navItems &&
                      navItems.map((item, index) => (
                        <li
                          className='List-item amp-mainNav-item amp-mainNav-item u-lg-hidden'
                          key={`menu-item-${index.toString()}`}>
                          {(item.linkType === '' ||
                            item.linkType === 'default' ||
                            item.linkType === 'primary-button-white' ||
                            item.linkType === 'primary-button-blue') && (
                            <a
                              className='amp-mainNav-link'
                              href={item.Link ? item.Link[0].string : '#'}
                              target={item.target}
                              onClick={() => handleDialogOpen(item.classes)}
                              rel='noopener noreferrer'>
                              {item.text}
                            </a>
                          )}
                          {item.linkType === 'phone' && (
                            <a
                              className={`amp-mainNav-link`}
                              href={item.Link ? `tel:${item.Link[0].string}` : '#'}
                              target={item.target}
                              rel='noopener noreferrer'>
                              {item.text}
                            </a>
                          )}
                        </li>
                      ))}
                  </ul>
                </>
              )}
            </nav>
          </div>
        </div>
      )}
    </>
  )
}

HeaderPersonalized.propTypes = {
  children: node,
  contentIdentifier: string,
  backgroundColor: string,
  backgroundContrast: string,
}

HeaderPersonalized.defaultProps = {
  children: null,
  contentIdentifier: '',
  backgroundColor: '',
  backgroundContrast: '',
}
